import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const titleApi = createApi({
  reducerPath: "title",
  tagTypes: ["Titles"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getTitles: builder.query({
      query: () => "api/v2/titles",
      transformResponse: (response: any) => {
        return response.titles;
      }
    })
  })
});

export const { useGetTitlesQuery } = titleApi;
